import { useCurrentEnterpriseId } from '@mews-commander/core';
import { OnboardingAuditFieldIdentifier } from '@mews-commander/data-access';
import { useMatchedGuideLink } from '@mews-commander/ui';
import { IconName, Link } from '@optimus-web/core';
import { auditToLinkProps } from './utils';

interface GuideLinkProps {
    fieldIdentifier: OnboardingAuditFieldIdentifier;
}

export const GuideLink = ({ fieldIdentifier }: GuideLinkProps) => {
    const enterpriseId = useCurrentEnterpriseId();
    const linkProps = auditToLinkProps(fieldIdentifier, { enterpriseId });
    const guideLink = useMatchedGuideLink(linkProps?.to);

    return guideLink ? (
        <Link variant="basic" size="small" href={guideLink} target="_blank" rel="noreferrer" icon={IconName.Help} />
    ) : null;
};
